<template>
  <div class="content" style="overflow-y: auto" >
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">姓名</div>
          <el-input
            size="mini"
            v-model="page.staffName"
            class="ipt-sty"
            clearable
            placeholder="请输入姓名"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">账号</div>
          <el-input
            size="mini"
            v-model="page.logonUser"
            class="ipt-sty"
            clearable
            placeholder="请输入账号"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">药企</div>
          <el-select
            size="mini"
            v-model="page.sendTenantGuid"
            filterable
            placeholder="请选择"
            filter
            class="ipt-sty"
            @change="changeTenantGuid"
          >
            <el-option
              v-for="item in tenantData"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="expand" @click="searchShow = !searchShow"><i :class="searchShow ? 'el-icon-arrow-up mr5' : 'el-icon-arrow-down mr5'"></i>{{searchShow ? '收起筛选':'更多筛选'}}</el-button>
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <div class="search-block mt15" v-if="searchShow">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div">销售区域</div>
            <el-select
              size="mini"
              v-model="page.salesTerritoryGuids"
              clearable
              multiple
              collapse-tags
              filterable
              placeholder="请选择"
              class="ipt-sty"
            >
              <el-option
                v-for="sa in salesTerritoryList"
                :key="sa.guid"
                :label="sa.territoryName"
                :value="sa.guid"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </div>
    <div>
      <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
        <div class="button-area">
          <el-button
            icon="el-icon-plus"
            size="mini"
            type="info"
            @click="add(1, '')"
            >新增人员</el-button
          >
          <el-button
            icon="el-icon-plus"
            size="mini"
            type="info"
            @click="addToPath(1, '')"
            >批量账号导入</el-button
          >
          <el-button size="mini" type="danger" @click="getDeleteData(1, '')"
            >批量删除</el-button
          >
          <div class="fr line-h40 h40 font-S16 mr16">
            有<b class="fontC-4fa1a4"> {{ page.totalRows }} </b>个备案人员
          </div>
          <!-- <el-button plain size="mini">历史数据</el-button> -->
        </div>

        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
          :height="tableHeight"
          stripe
          border
          style="width: 100%"
          v-loading="tableLoading"
        >
          <el-table-column
            type="selection"
            width="40"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="序号"
            width="60"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="姓名"
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="logonUser"
            label="账号"
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="organisationNames"
            label="组织"
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.organisationNames | roleNames }}
            </template>
          </el-table-column>
          <el-table-column
            prop="positionNames"
            label="岗位"
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.positionNames | roleNames }}
            </template>
          </el-table-column>
          <el-table-column
            prop="roleNames"
            label="角色"
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.roleNames | roleNames }}
            </template>
          </el-table-column>
          <el-table-column
            prop="salesTerritoryName"
            label="区域"
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="90"
            header-align="center"
            align="right"
          >
            <template slot-scope="scope">
              <a class="txt-color" @click="addJurisdiction(scope.row)"
                >编辑 |
              </a>
              <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)"
                >删除</a
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pt pb back-color-fff content-pagination-box"
        style="padding: 16px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div>
    <!-- 设置人员组织 -->
    <el-dialog title="人员设置" :visible.sync="visible" width="50%" left v-loading="tableLoading">
      <div>
        <el-form ref="ruleForm" :model="ruleForm" label-width="110px">
          <el-form-item label="组织名称：">
            <el-input placeholder="请输入组织名称过滤" v-model="filterText">
            </el-input>
            <el-tree
              :data="superiorOrganization"
              ref="treess"
              class="mt10 mb10 tree-sty"
              node-key="guid"
              :show-checkbox="true"
              :check-strictly="true"
              default-expand-all
              :filter-node-method="filterNode"
              :default-checked-keys="defaultCheckedKeys"
              @check-change="getCheckedNodesOfOrg"
              :props="defaultPropsOrganisation"
            >
            </el-tree>
          </el-form-item>
          <el-form-item label="销售区域：">
            <el-select
              v-model="ruleForm.salesTerritoryGuid"
              filterable
              placeholder="请选择"
              clearable
              class="w100f"
              size="small"
            >
              <el-option
                v-for="sa in getSalesTerritoryList"
                :key="sa.guid"
                :label="sa.territoryName"
                :value="sa.guid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位：">
            <el-select
              v-model="ruleForm.positionGuids"
              filterable
              clearable
              collapse-tags
              placeholder="请选择"
              class="w100f fl"
            >
              <el-option
                v-for="item in positionList"
                :key="item.guid"
                :label="item.positionName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色名称：">
            <span slot="label">
              <el-popover
                placement="top-start"
                content="可以使用其他人新建的角色，但是不可修改和删除"
                trigger="hover"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
              角色名称：
            </span>
            <el-cascader
              class="w100f"
              v-model="ruleForm.roleGuids"
              clearable
              collapse-tags
              size="small"
              filterable
              :options="roleList"
              :show-all-levels="true"
              :props="cascaderProps"
              @filter-method="filterNodeTree"
            ></el-cascader>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="mini" @click="visible = false">取消</el-button>
        <el-button
          size="mini"
          type="info"
          @click="upDateForm()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 新增部门/成员弹框 -->
    <el-dialog
      title="选择部门/人员"
      :visible.sync="visible3"
      width="60%"
      center
      v-loading="tableLoading"
    >
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input
              v-model="filterText2"
              class="mt15"
              placeholder="请输入部门/人员名称"
            ></el-input>
            <el-tree
              class="filter-tree mt10"
              :data="areaData"
              :props="defaultProps"
              :show-checkbox="true"
              node-key="guid"
              :filter-node-method="filterNodeDep"
              @node-click="handleNodeClick1"
              ref="treeDep"
              @check-change="checkChange"
            >
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <img :src="data.icon" alt="" />
                <!-- <img src="../../assets/images/icon_per.png" alt=""> -->
                <span
                  >{{ data.label }}
                  <span class="remark-class" v-if="data.remark"
                    >（{{ data.remark }}）</span
                  ></span
                >
              </div>
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}人</p>
            <el-button
              size="mini"
              type="danger"
              @click="delDepartment()"
              class="fr"
              style="margin-top: 5px"
              >批量删除
            </el-button>
            <el-table
              :data="departmentList"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="label"
                label="名称"
              >
                <template slot-scope="scope">
                  {{ scope.row.label }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="mini" @click="visible3 = false">取消</el-button>
        <el-button
          size="mini"
          type="info"
          @click="submitDepartment()"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 校验人员弹出框 -->

    <el-dialog 
     title="人员备案" 
     :visible.sync="dialogTableVisible"
     v-loading="tableLoading"
    >
      <div class="interlayer">
        <div class="promptWords">
          <img src="../../assets/mianicon.png" alt="" srcset="" /><span
            >存在备案在多家的人员,确定备案吗?</span
          >
        </div>
        <div style="max-width: 800px; overflow-x: auto">
          <el-table
            :data="dispalyArr"
            border
            highlight-current-row="true"
            style="max-height: 300px; overflow-y: auto"
            :header-cell-style="{ background: '#F2F2F2', color: '#212121' }"
            :row-class-name="tableRowClassName"
          >
            <el-table-column type="index" width="50" label="序号">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
                <!-- {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}} -->
              </template>
            </el-table-column>
            <el-table-column
              property="staffName"
              label="人员名称"
              width="96"
            ></el-table-column>
            <el-table-column property="idCode" label="身份证号" width="170">
              <template slot-scope="scope">
                <span>{{ handleIdCard(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              property="mobileNo"
              label="手机号"
              width="180"
            ></el-table-column>
            <el-table-column
              property="fillingsCompanyNames"
              label="备案公司"
            ></el-table-column>
          </el-table>
        </div>

        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="currentpage"
          :page-sizes="[10, 20, 30]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <div class="Lines"></div>
      <div class="functionButtons">
        <div class="downloadTheList">
          <!-- <img src="../../assets/dowonlod.png" alt="" srcset="" class="downloadIcon"> -->
          <!-- <el-button plain class="downloadButton" size="small">下载名单</el-button> -->
          <!-- <a href="" class="downloadButton">下载名单</a> -->
        </div>
        <div class="twoButtons">
          <el-button
            size="mini"
            class="cancelButton"
            type="info"
            @click="personnelFilingConfirmation"
          >
            确定</el-button
          >
          <el-button size="mini" class="okButton" @click="cancelTheEvent"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import areaJson from "../../assets/js/china_address_v4.js";
import citys from "../../components/citys.vue";
export default {
  components: {
    citys,
  },
  data() {
    return {
      searchShow:false,
      tableHeight: window.innerHeight - 280,
      contentMainHeight: window.innerHeight - 214,
      staffGuids: [],
      //分页数据
      pages: {},
      index: 1,
      //分页数据
      currentpage: 1,
      pagesize: 10,
      total: 0,

      //分页总数据v
      verifyPagingaArr: [],
      // 当前显示的数据
      dispalyArr: [],
      tenantData: [],
      visible: false,
      superiorOrganization: [],
      defaultCheckedKeys: [],
      appsideList: [],
      roleList: [],
      getSalesTerritoryList: [],
      salesTerritoryList:[],
      filterText: "",
      staffName: "",
      visible3: false,
      filterText2: "",
      departmentList: [],
      areaData: [],
      defaultProps: {
        id: "id",
        label: "label",
        children: "children",
      },
      departmentData: [],
      departList: [],
      workareaList: "",
      textTitle: "",
      right: "",
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      organisationGuidList: [],
      positionList: [],
      ruleForm: {
        userGuid: [],
        tenantGuid: "",
        organisationGuids: [],
        salesTerritoryGuid: "",
        salesTerritoryName: "",
        positionGuids: "",
        roleGuids: [],
        staffGuid: [],
      },
      selectedData: [], //树选中
      defaultPropsOrganisation: {
        id: "guid",
        label: "organisationName",
        children: "children",
        // disabled: this.disabledTreeNode
      },
      defaultPropsOrganisation1: {
        id: "guid",
        label: "organisationName",
        children: "children",
      },
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        sendTenantGuid: "",
        logonUser: "",
        staffName: "",
        logonUser: "",
        mobileNo: "",
        staffType: "1",
        bizState: "Y",
        organisationGuid: "",
        salesTerritoryGuids: null,
      },
      staffDetail: "",
      tableData: [],
      rules: {},
      multipleSelection: [],
      tableLoading: false,
      tenantList: [],
      addressOptions: areaJson,
      operationUnitList: [],
      delList: [],
      positionList: [],
      cascaderProps: {
        //角色级联
        value: "guid",
        label: "name",
        children: "children",
        multiple: true,
        emitPath: false,
      },
      tenantName: "",
      dialogTableVisible: false,
      // 表单数据

      // 注册公司
      fillingsCompanyNamesArr: [],
    };
  },
  watch: {
    searchShow(val, oldVal) {
      if(val) {
        this.tableHeight = window.innerHeight - 330;
        this.contentMainHeight = window.innerHeight - 264;
        return;
      }
      if(!val) {
        this.tableHeight = window.innerHeight - 280;
        this.contentMainHeight = window.innerHeight - 214;
        return;
      }
    },
    filterText(val) {
      this.$refs.treess.filter(val);
    },
    filterText2(val) {
      this.$refs.treeDep.filter(val);
    },
  },
  created() {
    this.areaData = [];
    this.getTenantData();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      } else if (rowIndex % 2 === 1) {
        return "success-row";
      }
      return "";
    },
    addToPath() {
      var self = this;
      self
        .$confirm(`确定导入【${this.tenantName}】的数据吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let routeUrl = this.$router.resolve({
            path: "/importPersonnelFiling",
            query: {
              sendTenantGuid: this.page.sendTenantGuid,
              tenantName: this.tenantName,
            },
          });
          window.open(routeUrl.href, "_blank");
        });
    },
    filterNodeTree(node, keyword) {},
    changeTenantGuid(val) {
      this.tenantData.forEach((i) => {
        if (val == i.sendTenantGuid) {
          this.tenantName = i.sendTenantName;
          console.log(this.tenantName);
        }
      });
      this.getData(true);
      this.getPosition();
      this.getSuperiorOrganization();
      this.getAppsideData();
      this.getAllSalesTerritory()
    },
    getTenantData(flg) {//flg从清空进入，药企不重置
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.$store.getters.getTenantGuid,
        serviceTenantGuid: self.$store.getters.getTenantGuid,
        isService: true,
      };
      self.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`,
          query
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantData = res.data.data;
            if (self.tenantData && self.tenantData.length) {
              if(!flg){
                self.page.sendTenantGuid = self.tenantData[0].sendTenantGuid;
                self.tenantName = self.tenantData[0].sendTenantName;
              }
              self.getData(true);
              self.getPosition();
              self.getSuperiorOrganization();
              self.getAppsideData();
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    addJurisdiction(row) {
      let self = this;
      console.log("部门", row);
      self.defaultCheckedKeys = [];
      self.ruleForm.organisationGuids = [];
      self.ruleForm.positionGuids = "";
      self.ruleForm.roleGuids = [];
      self.ruleForm.userGuid = "";
      self.ruleForm.staffGuid = "";
      self.filterText = "";
      self.ruleForm.userGuid = row.userGuid;
      self.ruleForm.staffGuid = row.guid;
      if (row.positionGuids) {
        self.ruleForm.positionGuids = row.positionGuids.toString();
      }
      self.ruleForm.roleGuids = row.roleGuids;
      self.visible = true;
      //设置树组件选中数据
      if (row.organisationGuids && row.organisationGuids.length > 0) {
        self.$nextTick(() => {
          self.ruleForm.organisationGuids = row.organisationGuids;
          self.defaultCheckedKeys = row.organisationGuids;
          self.$refs.treess.setCheckedKeys(row.organisationGuids);
          self.selectedData = self.$refs.treess.getCheckedNodes();
          self.getSalesTerritory();
        });
      } else {
        self.$refs.treess.setCheckedKeys(self.defaultCheckedKeys);
      }
      setTimeout(function () {
        self.ruleForm.salesTerritoryGuid = row.salesTerritoryGuid;
        self.ruleForm.salesTerritoryName = row.salesTerritoryName;
      }, 1200);
    },
    //获取岗位下拉框
    getPosition() {
      let self = this;
      let promise = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.page.sendTenantGuid,
      };
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/position/data/get`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.positionList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取组织树
    getSuperiorOrganization() {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      let sendTenantGuid = self.page.sendTenantGuid;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail-from-servicetenant?` +
            `tenantGuid=` +
            tenantGuid +
            "&sendTenantGuid=" +
            sendTenantGuid
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.superiorOrganization = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getCheckedNodesOfOrg() {
      this.ruleForm.organisationGuids = [];
      this.ruleForm.salesTerritoryGuid = "";
      this.ruleForm.salesTerritoryName = "";
      let resultData = this.$refs.treess.getCheckedNodes();
      if (resultData && resultData.length > 0) {
        resultData.forEach((i) => {
          this.ruleForm.organisationGuids.push(i.guid);
        });
      } else {
        this.ruleForm.organisationGuids = [];
      }
      this.getSalesTerritory();
      console.log(resultData);
      if (resultData.length < 6) {
        this.selectedData = resultData;
      } else {
        this.$message.warning("一个人员同一家公司最多只能属于5个部门!");
        this.$refs.treess.setCheckedNodes(this.selectedData);
      }
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex((one) => {
        return one == guid;
      });
      if (flag == -1) {
        return 0;
      } else {
        return 1;
      }
    },
    disabledTreeNode(data, node) {
      let list = this.selectedData;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids
            ? list[i].parentGuids
            : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    //获取组织的销售区域
    getSalesTerritory() {
      let self = this;
      let tenantGuid = self.page.sendTenantGuid;
      let promise = {
        tenantGuid: tenantGuid,
        organisationGuids: self.ruleForm.organisationGuids,
        pageIndex: 1,
        pageSize: 100,
      };
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/sales-territory/data/get-sales-territory`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (
              res.data.data.records != null &&
              this.ruleForm.organisationGuids &&
              this.ruleForm.organisationGuids.length > 0
            ) {
              self.getSalesTerritoryList = res.data.data.records;
            } else {
              self.getSalesTerritoryList = [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取销售区域
    getAllSalesTerritory() {
      let self = this;
      let tenantGuid = self.page.sendTenantGuid;
      let promise = {
        tenantGuid: tenantGuid,
        pageIndex: 1,
        pageSize: -1,
      };
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/sales-territory/data/get-sales-territory`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (
              res.data.data.records != null 
            ) {
              self.salesTerritoryList = res.data.data.records;
            } else {
              self.salesTerritoryList = [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取应用端
    getAppsideData() {
      let self = this;
      let promise = {
        guid: "",
        pageIndex: 1,
        appSideName: "",
        pageSize: 100,
        startTime: "",
        endTime: "",
        platformGuid: "1e2409b7ef0b412c2bb84e38f8fe50ba",
      };
      self.api
        .postJson(
          `/${serverConfig.msCommonAdminPlatformAuthService}/appside/data/get`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let appsideList = res.data.data.records;
            self.roleList = [];
            appsideList.forEach(function (item) {
              item.name = item.appSideName;
              if (item.name == "移动端" || item.name == "企业端") {
                self.getRoleListData(item);
              }
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getRoleListData(oneData) {
      let self = this;
      let promise = {
        bizState: "Y",
        tenantGuid: self.page.sendTenantGuid,
        appSideGuid: oneData.guid,
        pageSize: 100,
        isAdmin: JSON.parse(localStorage.userInfo).isAdmin,
      };
      self.api
        .postJson(
          `/${serverConfig.msCommonAdminPlatformAuthService}/role/data/get`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data.records ? res.data.data.records : [];
            data.forEach((item) => {
              item.name = item.roleName;
            });
            oneData.children = data;
            self.roleList.push(oneData);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },

    checkChange(val) {
      console.log(this.$refs.treeDep.getCheckedNodes());

      this.departmentList = [];
      let checkNodes = this.$refs.treeDep.getCheckedNodes();
      if (checkNodes.length > 0) {
        checkNodes.forEach((i) => {
          if (i.usertype == 1) {
            this.departmentList.push(i);
          }
        });
      }
      // this.departmentList = this.$refs.treeDep.getCheckedNodes();
      console.log("1111111", this.departmentList);
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //部门弹框选择
    handleNodeClick1(data) {
      let self = this;
      console.log(data);
      console.log(self.departmentList);
    },
    //获取组织
    getOrganisation() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-staff-hierarchical?&tenantGuid=` +
            self.$store.getters.getTenantGuid +
            "&sendTenantGuid=" +
            self.page.sendTenantGuid
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
            self.treeData(self.areaData);
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
          }
        });
    },
    treeData(areaData) {
      var self = this;
      // const treeData = [];
      // const getPerson = () => {};
      const fn = (tree) => {
        tree.forEach(async (k) => {
          k.label = k.organisationName;
          k.id = k.guid;
          //下面数据是我自己加上的,发请求需要
          // k.mobileNo = k.mobileNo;
          // k.organisationNames = k.organisationNames;
          // k.staffName = k.staffName;
          k.icon = require("../../assets/images/ico_ora.png");
          // 根据id获取人员数据,(注意转为树类型)
          if (k) {
            // const person = await self.getStaff(k.guid);
            k.staffList = [];
            if (k.staffs) {
              k.staffs.forEach((d) => {
                let item = {
                  usertype: 1,
                  id: d.guid,
                  label: d.staffName + d.mobileNo,
                  //下面数据是我自己加上的,发请求需要
                  mobileNo: d.mobileNo,
                  staffName: d.staffName,
                  tenantGuid: d.tenantGuid,
                  organisationNames: "123",
                  positionName: "123",
                  roleNames: "123",
                  logonUser: "123",
                  icon: require("../../assets/images/icon_per.png"),
                };
                k.staffList.push(item);
              });
            }
            const person = k.staffList;
            const isValid = (val) => {
              return val && val !== null && JSON.stringify(val) !== "[]";
            };
            // 将人员数据拼接到chilren里面
            if (k.children) {
              fn(k.children);
              isValid(person) && (k.children = [...k.children, ...person]);
              // 有子元素，需要调用自身
            } else {
              isValid(person) && (k.children = person);
            }
          }
        });
      };
      fn(areaData);
    },
    //查询人员
    getStaff(organisationGuid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: 10,
        tenantGuid: self.$store.getters.getTenantGuid,
        staffType: "1",
        bizState: "Y",
        organisationGuid: organisationGuid,
        sendTenantGuid: self.page.sendTenantGuid,
      };
      return new Promise((resolve, reject) => {
        self.api
          .postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              // self.tableLoading = false;
              const records = res.data.data.records;
              (records || []).forEach((k) => {
                k.label = k.staffName;
                k.id = k.guid;
                k.icon = require("../../assets/images/icon_per.png");
              });
              resolve(records);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    submitDepartment() {
      let self = this;

      if (!self.departmentList) {
        self.$message.error("请选择人员!");
        return;
      }
      let staffGuids = [];
      let listArr = [];
      self.departmentList.forEach((i) => {
        let obj = {
          name: i.staffName,
          logonUser: i.logonUser,
          mobileNo: i.mobileNo,
          organisationNames: i.organisationNames,
          positionName: i.positionName,
          roleNames: i.roleNames,
          sendTenantGuid: self.page.sendTenantGuid,
        };
        listArr.push(obj);
        staffGuids.push(i.id);
        console.log(staffGuids, "测试");
      });

      let query = {
        pageIndex: 1,
        queryVOList: listArr,
        pageSize: 10,
      };
      console.log('223');
      
      self.tableLoading = true;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff/data/list-exist-other-bkp-companies`,
          query
        )
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log(res);
            self.verifyPagingaArr = res.data.data.totalList;
            self.dispalyArr = self.verifyPagingaArr.slice(0, this.pagesize);
            self.total = res.data.data.totalRows;
            console.log(self.total);
            const arr = [];
            const idCodeArr = self.dispalyArr.forEach((item) =>
              arr.push(item.idCode)
            );
            console.log(arr);
            // self.verifyPagingaArr=self.verifyPagingaArr[0].fillingsCompanyNames
            // console.log(self.verifyPagingaArr[0].fillingsCompanyNames);
            self.visible3 = false;
            
            if (self.total == 0) {
              self.dialogTableVisible = false;
              this.personnelFilingConfirmation();
            } else {
              self.dialogTableVisible = true;
            }
          } else {
            self.$message.error(res.data.msg);
            self.verifyPagingaArr = [];
          }
        });
    },

    // 备案人员
    personnelFilingConfirmation() {
      let self = this;
      let staffGuids = [];
      let listArr = [];

      self.departmentList.forEach((i) => {
        console.log(i, "ljx");
        let obj = {
          name: i.staffName,
          logonUser: i.logonUser,
          mobileNo: i.mobileNo,
          organisationNames: i.organisationNames,
          positionName: i.positionName,
          roleNames: i.roleNames,
          sendTenantGuid: self.page.sendTenantGuid,
        };
        listArr.push(obj);
        staffGuids.push(i.id);
      });
      self.tableLoading = true;
      if (this.total == 0) {
        self.dialogTableVisibl = false;
        //   'serviceSenantGuid': self.$store.getters.getTenantGuid, 'tenantGuid': self.page.sendTenantGuid,
        self.api
          .postJson(
            `/${serverConfig.msPersonnelService}/staff/data/add-staff-filing`,
            {
              serviceSenantGuid: self.$store.getters.getTenantGuid,
              tenantGuid: self.page.sendTenantGuid,
              staffGuids: staffGuids,
            }
          )
          .then((res) => {
            self.tableLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success("添加备案人员成功");
              self.visible3 = false;

              this.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      } else {
        console.log(1111);
        self.dialogTableVisible = true;
        self.api
          .postJson(
            `/${serverConfig.msPersonnelService}/staff/data/add-staff-filing`,
            {
              serviceSenantGuid: self.$store.getters.getTenantGuid,
              tenantGuid: self.page.sendTenantGuid,
              staffGuids: staffGuids,
            }
          )
          .then((res) => {
            self.tableLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success("添加备案人员成功");
              self.visible3 = false;
              this.getData(true);
              self.dialogTableVisible = false;
            } else {
              self.$message.error(res.data.msg);
            }
          });
      }
    },
    //校验分页函数
    handleSizeChange1(val) {
      console.log(val);
      this.currentpage = 1;
      this.pagesize = val;

      this.dispalyArr = this.verifyPagingaArr.slice(0, val);
    },
    handleCurrentChange1(val) {
      console.log(val);
      this.currentpage = val;
      // 当前切换到第2页  每页10条
      // 数组里面 索引号 10  到 索引号 20
      // (val - 1) * this.pagesize   val * this.pagesize
      this.dispalyArr = this.verifyPagingaArr.slice(
        (val - 1) * this.pagesize,
        val * this.pagesize
      );
    },
    //关闭弹窗
    cancelTheEvent() {
      this.dialogTableVisible = false;
    },
    //身份证
    handleIdCard(item) {
      return item.idCode.slice(0, 11) + "********";
    },
    // handleIdCards(item){
    //   if(item.idCode){

    //   }
    // },

    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error("请勾选部门！");
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.id == j.id) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      this.$refs.treeDep.setCheckedNodes(this.departmentList);
    },
    //运营单元列表
    getOperationUnitList() {
      let self = this;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/operationunit/data/get`,
          { tenantGuid: self.$store.getters.getTenantGuid, isService: true }
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.operationUnitList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    incres(area) {
      let self = this;
      self.ruleForm.province = area[0];
      self.ruleForm.city = area[1];
      self.ruleForm.district = area[2];
    },
    handleNodeCilck(data) {
      let self = this;
      self.ruleForm.organisationGuid = data.guid;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        sendTenantGuid: self.page.sendTenantGuid,
        logonUser: "",
        staffName: "",
        logonUser: "",
        mobileNo: "",
        staffType: "1",
        bizState: "Y",
        salesTerritoryGuids: null,
      };
      this.getTenantData(1);
    },
    add(flg, row) {
      let self = this;
      self.workareaList = [];
      if (flg == 1) {
        self.textTitle = "新增人员";
        self.visible3 = true;
        self.departmentList = [];
        self.delList = [];
        this.getOrganisation();
        self.$nextTick(() => {
          self.$refs.treeDep.setCheckedNodes(self.departmentList);
        });
      } else {
        self.textTitle = "编辑人员";
        self.ruleForm.guid = row.guid;
        self.workareaList.push(row.province, row.city, row.district);
        self.getStaffDetail(row.guid);
      }
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.page.staffType = "2";
      self.tableLoading = true;
      // self.page.pageSize = 10;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff/data/get`,
          self.page
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log(res);
            self.tableLoading = false;
            self.tableData = res.data.data.records;
            // console.log(self.tableData);
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error("请勾选数据！");
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      let DeleteStaffRequestVO = {
        guids: self.multipleSelection,
        tenantGuid: self.$store.getters.getTenantGuid,
        isVaildInitStaff: true,
        sendTenantGuid:this.page.sendTenantGuid // 药企guid
      };
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.api
            .postJson(
              `/${serverConfig.msPersonnelService}/staff/data/delete-by-tenant`,
              DeleteStaffRequestVO
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success("删除人员成功");
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    upDateForm() {
      let self = this;
      if (self.ruleForm.salesTerritoryGuid) {
        self.getSalesTerritoryList.forEach((i) => {
          if (self.ruleForm.salesTerritoryGuid == i.guid) {
            self.ruleForm.salesTerritoryName = i.territoryName;
          }
        });
      }
      let userGuids = [];
      userGuids.push(self.ruleForm.userGuid);
      let staffGuids = [];
      staffGuids.push(self.ruleForm.staffGuid);
      let positionGuids = [];
      positionGuids.push(self.ruleForm.positionGuids);
      if (
        self.ruleForm.salesTerritoryGuid == "" ||
        self.ruleForm.salesTerritoryGuid == null
      ) {
        self.ruleForm.salesTerritoryName = "";
      }
      let salesTerritory = {
        salesTerritoryGuid: self.ruleForm.salesTerritoryGuid,
        salesTerritoryName: self.ruleForm.salesTerritoryName,
      };
      let promise = {
        userGuids: userGuids,
        staffGuids: staffGuids,
        tenantGuid: self.page.sendTenantGuid,
        organisationGuid: self.ruleForm.organisationGuids,
        positionGuid: positionGuids,
        roleGuid: self.ruleForm.roleGuids,
        salesTerritory: salesTerritory,
      };
      self.tableLoading = true;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff/set-data-privilege`,
          promise
        )
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.visible = false;
            self.$message.success("人员编辑成功");
            self.getData(false);
            // this.dialogTableVisible=true
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData(false);
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData(false);
    },
    getLevel(val) {
      let self = this;
      console.log("789", val, val.length);
      if (val.length > 0) {
        self.ruleForm.organisationGuid = val[val.length - 1].toString();
      }
      // console.log(self.ruleForm.level);
    },
  },
};
</script>
<style scoped>
/* .el-table .warning-row {
    background: red;
  }

.el-table .success-row {
    background: #fff;
  } */
.search-area-div {
  width: 60px;
}
::v-deep .el-dialog {
  position: relative;
  width: 800px;
  /* height: 540px; */
}
::v-deep .el-dialog .el-dialog__body {
  padding: 10px 16px 10px;
}
::v-deep .interlayer .el-dialog__body {
  width: 688px;
  height: 100%;
  padding: 0px;
}
::v-deep .interlayer .el-dialog__body {
  width: 100%;
  height: 52px;
  border: 1px solid #000;
}

::v-deep .el-dialog__title {
  position: relative;
  font-size: 18px;
  padding: 12px 20px;
}
.interlayer {
  position: relative;
  border: 1px solid #ffffff;
  padding: 0px;
}
::v-deep .downloadButton {
  float: left;
  margin: 24px 0 10px 0px;
  border: 1px solid #ffffff;
  text-decoration: none;
  color: #4fa1a4;
}
.interlayer .promptWords {
  display: inline-block;
  background-color: #fffbf2;
  width: 100%;
  height: 32px;
  border: 1px solid #fff1d4;
  text-align: center;
  line-height: 32px;
  margin-bottom: 10px;
}
.interlayer .promptWords span {
  float: left;
  margin-left: 8px;
  color: #212121;
}
::v-deep .interlayer .el-button--info.is-plain {
  float: right;
  margin: 10px 20px 10px 0px;
  background-color: #4fa1a4;
  color: #fff;
}
.confirmButton {
  float: right;
  margin: 11px 12px 11px 0px;
}
.interlayer .promptWords img {
  float: left;
  width: 16px;
  margin: 8px 0px 8px 23px;
}
::v-deep .el-dialog__header {
  display: flex;
  position: relative;
  border: 1px solid #d9d9d9;
}
.functionButtons {
  /* position: absolute; */
  vertical-align: baseline;
  /* bottom: 0px;
  left: 0px; */
  width: 720px;
  height: 50px;
  /* border-top: 1px solid #D9D9D9; */
}
/* 字体大小 */

::v-deep .interlayer .el-table .cell {
  font-size: 14px;
  font-weight: 500;
  color: #212121;
}

::v-deep .interlayer .el-table tr {
  height: 40px !important;
  background-color: #f2f2f2;
}
.interlayer .el-table .el-table__cell {
  padding: 0px;
}
::v-deep .downloadIcon {
  float: left;
  width: 18px;
  height: 18px;
  margin: 24px 3px 16px 20px;
  border: 0px none #ffffff;
}
.twoButtons {
  padding-top: 10px;
}
.cancelButton {
  float: right;
  margin: 11.5px -40px 10px 0px;
  background-color: #4fa1a4;
  color: #fff;
}
.okButton {
  float: right;
  margin: 11px 12px 11px 0px;
  border: 1px solid #d9d9d9;
  color: #212121;
}
.el-pagination {
  padding: 11px 5px;
}
.Lines {
  position: absolute;
  bottom: 50px;
  left: 0px;
  width: 800px;
  height: 1px;
  background-color: #d9d9d9;
}

/* .downloadTheList{
  padding-top: 11px;
} */

.ipt-sty {
  width: 70% !important;
}
.tree-sty {
  max-height: 320px;
  overflow: auto;
}
.person-type /deep/.el-radio {
  margin-right: 10px;
}

/* 选项卡 */
.menu-tab {
  width: 20%;
  float: left;
  padding: 15px;
  box-sizing: border-box;
}

.tab-plane {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  /* border-radius: 6px; */
  border: 1px solid #ddd;
}

.tab-plane .tab-list {
  width: 50%;
  line-height: 32px;
  background: rgb(240, 239, 239);
  cursor: pointer;
  /* border-radius: 6px; */
}

.tab-active {
  color: #4fa1a4 !important;
  background: #fff !important;
  border: 1px solid #4fa1a4;
}

.tags-logo {
  width: 16px;
  margin-top: 2px;
  margin-right: 10px;
}

.tags-edit {
  width: 20px;
  margin-top: 2px;
  margin-right: 10px;
}

.tags-del {
  width: 16px;
  margin-top: 2px;
}

.tags-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  /* line-height: 40px; */
  text-align: left;
  padding: 0 10px;
  cursor: pointer;
}

.tags-list-left {
  width: calc(100% - 60px);
  display: flex;
  align-items: center;
}

.tags-list-left span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-list:hover {
  background: rgb(245, 244, 244);
}

.tags-active {
  color: #4fa1a4 !important;
  background: rgb(245, 244, 244);
}

.edit-tags-text {
  padding: 0 80px;
  display: flex;
}

/* 表格 */
.table-tags {
  display: flex;
  justify-content: space-between;
}

.person-tags {
}

.tags-left {
  font-weight: 600;
}

.tags-right {
  cursor: pointer;
  text-decoration: underline;
}

.tags-detail {
  padding: 0 60px;
  text-align: left;
  margin-bottom: 30px;
}

.tags-detail-name {
  display: inline-block;
  width: 120px;
  text-align: right;
  margin-right: 20px;
}

.tags-detail-title {
  font-size: 16px;
  font-weight: 700;
}

.sure-btn {
  width: 50%;
  color: #fff;
  background: #4fa1a4;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.tab-input {
  width: 100%;
  margin-bottom: 10px;
}

.custom-tree-node {
  display: flex;
  align-items: center;
}

.custom-tree-node img {
  width: 18px;
  margin-right: 10px;
}
::v-deep .el-table .el-table__cell {
  padding: 0px;
}
::v-deep .interlayer .el-table tr:nth-child(odd) {
  background-color: #ffffff;
}
::v-deep .interlayer .el-table tr:nth-child(even) {
  background-color: #fafafa;
}
</style>
